var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4785 11.4732C16.7098 10.3218 16.237 8.99849 16.102 7.62062L16.0071 6.71877C15.8543 5.23262 15.1558 3.85592 14.0467 2.85498C12.9376 1.85404 11.4967 1.29999 10.0027 1.29999C8.5087 1.29999 7.06779 1.85404 5.95868 2.85498C4.84957 3.85592 4.15107 5.23262 3.99829 6.71877L3.90336 7.62062C3.76708 8.99575 3.29433 10.3162 2.52686 11.4653C2.26257 11.8588 2.11039 12.3168 2.08665 12.7902C2.06291 13.2636 2.16851 13.7346 2.39212 14.1525C2.61573 14.5704 2.9489 14.9196 3.3559 15.1626C3.7629 15.4055 4.22837 15.5331 4.70237 15.5316H15.303C15.7758 15.5321 16.2398 15.4043 16.6455 15.1617C17.0513 14.9192 17.3836 14.571 17.607 14.1544C17.8303 13.7377 17.9363 13.2682 17.9137 12.796C17.8911 12.3238 17.7407 11.8666 17.4785 11.4732Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28845 17.1138C7.56005 17.5943 7.95438 17.9941 8.43113 18.2722C8.90788 18.5504 9.44994 18.697 10.0019 18.697C10.5539 18.697 11.0959 18.5504 11.5727 18.2722C12.0494 17.9941 12.4438 17.5943 12.7154 17.1138H7.28845Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.08b11c96573f982803e17202cf5ec3f3.svg";
export { ForwardRef as ReactComponent };